export class Subject{
    Id: number;
    Name: string;
    Description:  string;

    // atributos que no pertencen a la clase
    Class: string;

    constructor() {
    }

}



// WEBPACK FOOTER //
// ./src/app/main/models/subjects/subject.ts